module.exports = __webpack_public_path__ + "static/media/page-404.2fe54284.svg";